var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1379 0.86193C11.3983 1.12228 11.3983 1.54439 11.1379 1.80474L1.80458 11.1381C1.54423 11.3984 1.12212 11.3984 0.861766 11.1381C0.601417 10.8777 0.601417 10.4556 0.861766 10.1953L10.1951 0.86193C10.4554 0.601581 10.8776 0.601581 11.1379 0.86193Z",
    fill: "#960035",
    stroke: "#960035",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.861726 0.86193C0.601377 1.12228 0.601377 1.54439 0.861726 1.80474L10.1951 11.1381C10.4554 11.3984 10.8775 11.3984 11.1379 11.1381C11.3982 10.8777 11.3982 10.4556 11.1379 10.1953L1.80453 0.86193C1.54419 0.601581 1.12208 0.601581 0.861726 0.86193Z",
    fill: "#960035",
    stroke: "#960035",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineCross);
export default __webpack_public_path__ + "static/media/DeclineCross.27ef38b6e32b8aee65fc3bf3a7106e6a.svg";
export { ForwardRef as ReactComponent };